import { IBaseResponse } from 'shared/typings';

export enum EWithdrawalStatuses {
	IN_PROGRESS = 'in_progress',
	SUCCESS = 'success',
	FAILED = 'failed',
}

export enum ETransactionReasons {
	BONUS = 'bonus',
	ACTION = 'action',
	WITHDRAWAL = 'withdrawal',
	ADJUSTMENT = 'adjustment',
}

export enum ETransactionTypes {
	REPLENISHMENT = 'replenishment',
	DEDUCTION = 'deduction',
}

export interface ITransaction {
	offer: {
		additionalProp1: string;
		additionalProp2: string;
		additionalProp3: string;
	} | null;
	source: {
		additionalProp1: string;
		additionalProp2: string;
		additionalProp3: string;
	} | null;
	currency: string;
	amount: string;
	action_uuid: string;
	reason: ETransactionReasons;
	comment: string;
	created_at: string;
	transferred_to_payment_system: boolean;
}

export interface IWithdrawal {
	uuid: string;
	created_at: string;
	amount: string;
	status: EWithdrawalStatuses;
	payment_system_account_url: string;
}

export type TTransactionsList = IBaseResponse<ITransaction[] | null>;
